export default __webpack_public_path__ + "static/media/pay-farmers.3f388bbf.jpeg";